import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const AdminPreferencesService = {
  getCombineYears,
  getLeagueNames,
  getCombineNames,
  getCombineNamesID,
  getAdminPrefMaxVoteDetails,
  insertUpdateAdminPrefBallotVoteCount,
  getAdminPrefBallotVotingDateTimeDetails,
  insertUpdateAdminPrefBallotVotingDateTime,
  getCurrentEnabledBallotVoteEventDetails,
  getEventName,
};

async function getCombineYears() {
  const response = await APIHelper.get(
    APIURLConstants.GET_COMBINE_YEARS,
    authHeader()
  );
  return response;
}
async function getEventName(year) {
  const response = await APIHelper.get(
    APIURLConstants.GET_EVENT_NAME(year),
    authHeader()
  );
  return response;
}
async function getLeagueNames() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_LEAGUE_NAMES}`,
    authHeader()
  );
  return response;
}
async function getCombineNames() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_COMBINE_NAMES}`,
    authHeader()
  );
  return response;
}
async function getCombineNamesID(leagueid) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_COMBINE_NAMES_ID(leagueid)}`,
    authHeader()
  );
  return response;
}
async function getAdminPrefMaxVoteDetails() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_ADMIN_PREF_MAX_VOTE_DETAILS}`,
    authHeader()
  );
  return response;
}
async function insertUpdateAdminPrefBallotVoteCount(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_ADMIN_PREF_BALLOT_VOTE_COUNT}`,
    formObj,
    authHeader()
  );
  return response;
}
async function getAdminPrefBallotVotingDateTimeDetails() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_ADMIN_PREF_BALLOT_VOTING_DATE_TIME_DETAILS}`,
    authHeader()
  );
  return response;
}
async function insertUpdateAdminPrefBallotVotingDateTime(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_ADMIN_PREF_BALLOT_VOTING_DATE_TIME}`,
    formObj,
    authHeader()
  );
  return response;
}
async function getCurrentEnabledBallotVoteEventDetails() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_CURRENT_ENABLED_BALLOT_VOTE_EVENT_DETAILS}`,
    authHeader()
  );
  return response;
}
